import Button from "./Button";

export default function PrintButton() {
    return (<Button id="print-button" 
        className="btn-sm btn-primary" 
        onClick={() => window.print()} 
        icon={<i className="bi bi-printer me-1"></i>}
        iconLocation="start" 
        text="Print"/>);
}